export default __webpack_public_path__ + "resources/icons/n340-2185.png";